import { mapActions, mapGetters } from "vuex";
import { STATUS_MESSAGES, SYSTEM_MESSAGES } from "@/messages/System";
import { CHAT_APIs } from "@/configs/APIs";
import { ENV_CONFIGS, MAPPING_URL_SOURCES, STREAM_CONFIGS } from "@/configs/Settings";
import { DEFAULT_VALUES, STATUS_RESPONSES, TESTING_CONFIGS, TOKEN_TYPES } from "@/configs/SDK";
import { isInIframe } from "@/ultis/Helper";

export default {
   name: "ChannelStreamMixins",
   data() {
      return {
         intervalPingId: null,
         intervalTrackingActiveUserId: null,
         isCalledJoinApi: false,
         videoSources: {},
         urlSources: [],

         videoTokens: {
            token: "",
            type: TOKEN_TYPES.AKAIMA
         },

         // Debug url playing:
         urlPlaying: null,
         reRenderVideoPlayer: 0,
         trackingMetadata: {
            viewerId: 0,
            assetName: "",
            defaultResource: "",
            "c3.cm.contentType": "Live",
            "c3.cm.channel": "NA",
            "c3.cm.brand": "NA",
            "c3.cm.affiliate": "NA",
            "c3.cm.categoryType": "NA",
            "c3.cm.name": "NA",
            "c3.cm.id": "NA",
            "c3.cm.seriesName": "NA",
            "c3.cm.seasonNumber": "NA",
            "c3.cm.showTitle": "NA",
            "c3.cm.episodeNumber": "NA",
            "c3.cm.genre": "NA",
            "c3.cm.genreList": "NA"
         }
      };
   },
   computed: {
      ...mapGetters(["user", "streamDetail"])
   },
   watch: {},
   created() {},
   mounted() {
      this.$root.$on("reload-video-sources", async () => {
         this.urlSources = [];
         await this.getVideoSources(DEFAULT_VALUES.JSON_FILE_2);
      });
   },
   methods: {
      ...mapActions(["updateCurrentChannel", "updateIsJoinedChannel", "updateStreamStatistic"]),
      getChatChannel() {
         this.$store.dispatch("updateIsJoinedChannel", false);
         this.$http
            .post(CHAT_APIs.GET_CHAT_CHANNEL, {
               slug: this.streamDetail && this.streamDetail.key ? this.streamDetail.key : DEFAULT_VALUES.SLUG
            })
            .then((response) => {
               if (response.data) {
                  this.$store.dispatch("updateCurrentChannel", response.data.viewer_channel);
               }
            })
            .catch((error) => {
               console.log(error);
               this.$toastr.e(SYSTEM_MESSAGES.CONTACT_ADMIN, STATUS_MESSAGES.ERROR);
            })
            .then(() => {
               this.createPingInterval();
            });
      },
      async createPingInterval() {
         this.pingChatStatistic();

         // this.intervalTrackingActiveUserId = setInterval(async () => {
         //    this.isCalledJoinApi = false;
         //    this.pingUserJoin();
         // }, STREAM_CONFIGS.TIME_TRACKING_USER_JOIN * 1000);

         this.intervalPingId = setInterval(async () => {
            // let randomDelay = 0;
            // if (!this.isCalledJoinApi) {
            //    randomDelay = parseFloat((Math.random() * 3).toFixed(2)); // random in 0-3s
            // }
            this.pingChatStatistic();
            // setTimeout(async () => {
            // }, 1000 * randomDelay)
         }, STREAM_CONFIGS.TIME_GET_STATISTIC * 1000);
      },
      pingChatStatistic() {
         this.$http
            .post(CHAT_APIs.GET_STATISTIC_CHANNEL, {
               slug: this.streamDetail && this.streamDetail.key ? this.streamDetail.key : DEFAULT_VALUES.SLUG
            })
            .then((response) => {
               if (response.data) {
                  let statisticData = response.data;
                  delete statisticData.view_count;
                  this.$store.dispatch("updateStreamStatistic", statisticData);
               }
            })
            .catch((error) => {
               console.log(error);
            })
            .then(() => {});
      },
      async pingUserJoin() {
         this.$http
            .post(CHAT_APIs.USER_JOIN_STREAM, {
               slug: this.streamDetail && this.streamDetail.key ? this.streamDetail.key : DEFAULT_VALUES.SLUG
            })
            .then(() => {
               this.isCalledJoinApi = true;
            })
            .catch((error) => {
               console.log(error);
            });
      },
      async clearPingStatistic() {
         clearInterval(this.intervalPingId);
         this.intervalPingId = null;
      },
      async clearPingUserActive() {
         clearInterval(this.intervalTrackingActiveUserId);
         this.intervalTrackingActiveUserId = null;
      },
      async getVideoSources(urlDefault = DEFAULT_VALUES.JSON_FILE) {
         if (!this.streamDetail || !this.streamDetail.streamUrl) return;
         let url = this.streamDetail.streamUrl;

         if (TESTING_CONFIGS.IS_USING_LOCAL_JSON) {
            url = urlDefault;
         }

         if (TESTING_CONFIGS.IS_USING_AXIOS_TO_FETCH) {
            this.$http
               .get(url)
               .then((response) => {
                  if (response.data.code === STATUS_RESPONSES.SUCCESS) {
                     this.videoSources = response.data;
                     this.updateVideoSources();
                     // this.urlSources.unshift(DEFAULT_VALUES.FAILED_URL_SOURCE); // Add test url
                     this.afterGetVideoSources();
                  }
               })
               .catch((error) => {
                  console.log(error);
                  if (ENV_CONFIGS.IS_HARD_URL) {
                     this.urlSources = [].concat(DEFAULT_VALUES.URL_SOURCES); // Add test url
                  }
               })
               .then(() => {});
         } else {
            fetch(url).then(async (response) => {
               if (response.status !== 200) {
                  this.$toastr.e(`Looks like there was a problem`, STATUS_MESSAGES.ERROR);
                  if (!isInIframe()) {
                     setTimeout(() => {
                        window.location.href = "/";
                     }, 3000);
                  }
                  return;
               }

               // Examine the text in the response
               await response.json().then((data) => {
                  if (ENV_CONFIGS.IS_HARD_URL) {
                     this.urlSources = [].concat(DEFAULT_VALUES.URL_SOURCES); // Add test url
                  } else if (data && data[MAPPING_URL_SOURCES.BROADCASTER]) {
                     this.videoSources = data;
                     this.updateVideoSources();
                     // this.urlSources.unshift(DEFAULT_VALUES.FAILED_URL_SOURCE); // Add test url
                  }
                  this.afterGetVideoSources();
               });
            });
         }
      },
      updateVideoSources() {
         if (this.videoSources && this.videoSources[MAPPING_URL_SOURCES.BROADCASTER]) {
            this.urlSources = this.videoSources[MAPPING_URL_SOURCES.BROADCASTER][MAPPING_URL_SOURCES.DATA_FEED];
            this.trackingMetadata = {
               ...this.trackingMetadata,
               defaultResource: this.streamDetail.streamUrl || "",
               viewerId: this.user.userInfo?.userId || 0,
               assetName: this.videoSources[MAPPING_URL_SOURCES.BROADCASTER][MAPPING_URL_SOURCES.DESCRIPTION] || "Rakuten Event"
            };
         }
      },
      afterGetVideoSources() {},
      updateUrlPlaying(val) {
         this.urlPlaying = val;
      },
      updateUrlTesting(url, token = "", isJwt = false) {
         this.videoTokens = Object.assign(this.videoTokens, {
            token: token.trim(),
            type: isJwt ? TOKEN_TYPES.JWT : TOKEN_TYPES.AKAIMA
         });

         this.reRenderVideoPlayer++;
         this.urlSources = [].splice(0, 0);
         this.urlSources = [url];
      }
   },
   async beforeDestroy() {
      await this.clearPingStatistic();
      await this.clearPingUserActive();
   }
};
